export const transactionInfoTypes = [
  {
    label: 'Informative',
    value: 'false',
    selected: true,
  },
  {
    label: 'Uninformative',
    value: 'true',
    selected: true,
  },
];

export default transactionInfoTypes;
